<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" ref="close" @click="goBack()">×</button>
                <h4 class="modal-title">{{ $t('assign_to') }}</h4>
            </div>
            <div class="modal-body" v-pml-block="isLoading">
                <div v-if="lead">

                    <!--Lead info-->
                    <div class="modal_deal">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-7">
                                <div class="d_table w_full">
                                    <div class="d_t_cell w_50">
                                        <a :href="`/leads/${lead.id}`" target="_blank" class="pull-left m-r-10">
                                            <img class="img-circle thumb-md" :src="lead.avatar || `/static/images/avatar.jpg`">
                                        </a>
                                    </div>
                                    <div class="d_t_cell">
                                        <a :href="`/leads/${lead.id}`" target="blank">
                                            <p class="option__title bold m-0 f_size_14">{{ lead.name }}</p>
                                        </a>
                                        <small class="option__small c_default show bold">{{ lead.email }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-5">
                                <div class="m-t-15 t_right">
                                    <b class="m-r-10">{{ $t('deals') }}:</b>
                                    <label class="label label-warning f_size_12" v-pml-tooltip="$t('open_as')"><i class="fa-fw fa fa-coffee"></i> {{ lead.deals_counter.open }}</label>
                                    <label class="label label-default f_size_12" v-pml-tooltip="$t('sold_as')"><i class="fa-fw fa fa-thumbs-up"></i> {{ lead.deals_counter.sold }}</label>
                                    <label class="label label-danger f_size_12" v-pml-tooltip="$t('lost_as')"><i class="fa-fw fa fa-thumbs-down"></i> {{ lead.deals_counter.lost }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Deals availables -->
                    <div class="modal_deal">
                        <div class="clearfix card_deal_email box_shadow_hover m-b-10" v-for="item in lead.deals" @click="dealId = item.id">

                            <input type="radio" :checked="dealId === item.id">

                            <div class="card-box p-10 relative card_color_left" :style="`border-left-color: ${getSegmentColor(item.segment)}`">

                                <div class="table-box table_fixed">

                                    <!-- Infos -->
                                    <div class="table-detail p-r-10">
                                        <router-link :to="{ name: 'deals.show', params: { id: item.id } }" target="_blank">
                                            <strong class="m-t-0 m-b-5 f_size_14">#{{ item.code }}</strong>
                                        </router-link>
                                        <span v-if="item.status" class="label pull-right" :class="getStatusColor(item.status)" v-pml-tooltip="$t('status')">{{ $t(item.status) }}</span>
                                        <small class="c_default show bold t_overflow m-t-5">{{ item.created_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                                    </div>

                                    <div class="table-detail">
                                        <div class="row">

                                            <!-- Consultant -->
                                            <div class="col-xs-12 col-sm-6 col-md-12">
                                                <span class="text-muted" v-if="item.member" v-pml-tooltip="$t('consultant')">
                                                    <i class="md-headset-mic text-dark"></i> {{ item.member.name }}
                                                </span>
                                            </div>

                                            <!-- Follower -->
                                            <div class="col-xs-12 col-sm-6 col-md-12">
                                                <small class="text-muted" v-if="item.follower" v-pml-tooltip="$t('follower')">
                                                    <i class="fa fa-location-arrow text-dark m-r-5"></i> {{ item.follower.name }}
                                                </small>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="table-detail table_divider_mobile t_center">

                                        <!-- Source -->
                                        <span class="label label-default" :style="`background-color:${item.source.color}`" v-pml-tooltip="$t('source')" v-if="item.source">{{ item.source.name }}</span>

                                        <!-- Pipeline -->
                                        <small class="text-muted m-t-5 show" v-if="item.pipeline_step_id" v-pml-tooltip="$t('pipeline')">
                                            <i class="fa fa-toggle-right text-dark m-r-5"></i> {{ item.step.pipeline.name }} <i class="fa fa-long-arrow-right"></i> {{ item.step.name }}
                                        </small>

                                    </div>

                                    <!-- Perception -->
                                    <div class="table-detail table_divider_mobile t_center w_100">
                                        <span v-if="item.perception" class="label" :class="getPerceptionColor(item.perception)" v-pml-tooltip="$t('perception')">
                                            {{ $t(item.perception) }}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!-- Create a new deal attach it -->
                        <div class="clearfix card_deal_email box_shadow_hover" @click="dealId = 'new'">

                            <input type="radio" :checked="dealId === 'new'">

                            <div class="card-box p-10 relative card_color_left">
                                {{ $t('create_a_new_deal') }}
                            </div>
                        </div>
                    </div>

                </div>

                <div class="clearfix p-15">
                    <button class="btn btn-white pull-left" @click="goBack()">{{ $t('cancel') }}</button>
                    <button class="btn btn-default pull-right" :disabled="!dealId" @click.prevent="attach" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import bus from '@/utils/events/bus'
    import RoutedModals from '@/utils/mixins/routed-modals'
    import Notify from '@/utils/helpers/notify'
    import {trans} from '@/utils/helpers/translation'
    import {getHandler, attachDeal} from '@/services/emails'

    export default {
        name: 'EmailHandler',
        mixins: [ RoutedModals ],
        data () {
            return {
                email: {},
                dealId: null,
                isLoading: false,
                isSaving: false
            }
        },
        created () {
            this.fetch(this.$route.params.id)
        },
        computed: {
            lead () {
                return this.email.lead || null
            }
        },
        methods: {
            fetch (id) {
                this.isLoading = true

                getHandler(id)
                    .then(response => {
                        this.email = response.data
                    })
                    .catch(() => {
                        Notify.error(trans('_notifications.error'))
                        window.jQuery(this.$refs.close).trigger('click')
                    })
                    .then(() => {
                        this.isLoading = false
                    })
            },
            attach () {
                this.isSaving = true

                attachDeal(this.email.id, this.dealId)
                    .then(() => {
                        bus.$emit('doFilterEmails')
                    })
                    .catch(() => {
                        Notify.error(trans('_notifications.error'))
                    })
                    .then(() => {
                        window.jQuery(this.$refs.close).trigger('click')
                    })
            },
            getSegmentColor (segment) {
                return segment ? segment.color : ''
            },
            getPerceptionColor (perception) {
                if (perception === 'hot') return 'label-danger'
                if (perception === 'cold') return 'label-primary'
                if (perception === 'warm') return 'label-warning'
                if (perception === 'no_perception') return 'label-light'
            },
            getStatusColor (status) {
                if (status === 'open') return 'label-warning'
                if (status === 'sold') return 'label-success'
                if (status === 'lost') return 'label-danger'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/components/Handler.vue